// composables/useSubCategoryNavigation.ts
import { ref, computed } from 'vue'
import type { Schemas } from "#shopware"

type NavigationElement = Schemas["Category"] & {
  activeClass?: boolean;
};

export function useSubCategoryNavigation() {
  const { navigationElements } = useNavigation();
  const { category } = useCategory();
  
  function findByIdRecursive(obj: any, targetId: string) {
    if (obj.id === targetId) {
      return obj;
    }

    if (Array.isArray(obj.children)) {
      for (const child of obj.children) {
        const result: any = findByIdRecursive(child, targetId);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  function findById(obj: any, categoryId: string) {
    let result: any = null;
    obj.forEach((element: any) => {
      if (result === null) {
        result = findByIdRecursive(element, categoryId);
      }
    });
    return result;
  }

  const categoryResponse = ref();
  categoryResponse.value = findById(navigationElements.value, category.value?.id);

  const subCategories = computed(
    () => categoryResponse?.value?.children || ([] as NavigationElement[])
  );

  const isCategoryFilterVisible = ref<boolean>(false);
  const toggleCategoryFilter = () => {
    isCategoryFilterVisible.value = !isCategoryFilterVisible.value;
  };

  return {
    subCategories,
    isCategoryFilterVisible,
    toggleCategoryFilter,
    categoryResponse
  }
}